import { render, staticRenderFns } from "./turnCount.vue?vue&type=template&id=916e7eba&scoped=true&"
import script from "./turnCount.vue?vue&type=script&lang=js&"
export * from "./turnCount.vue?vue&type=script&lang=js&"
import style0 from "./turnCount.vue?vue&type=style&index=0&id=916e7eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916e7eba",
  null
  
)

export default component.exports